import { Plugin } from '@nuxt/types'
import { ModalAlertService } from '@/services/ModalAlertService'
import { ModalShelfDiagramService } from '@/services/ModalShelfDiagramService'
import { ModalErrorService } from '@/services/ModalErrorService'
import { ModalCodeService } from '@/services/ModalCodeService'
import { ModalUserSearchService } from '@/services/ModalUserSearchService'
import { ModalUserDetailService } from '@/services/ModalUserDetailService'
import { ModalBibliographySearchConditionService } from '@/services/ModalBibliographySearchConditionService'
import { ModalBibliographySearchResultService } from '@/services/ModalBibliographySearchResultService'
import { ModalBibliographySearchResultAuthorityService } from '@/services/ModalBibliographySearchResultAuthorityService'
import { ModalBibliographySearchResultContentService } from '@/services/ModalBibliographySearchResultContentService'
import { ModalBibliographySearchHistoryService } from '@/services/ModalBibliographySearchHistoryService'
import { ModalCodeKeyService } from '@/services/ModalCodeKeyService'
import { ModalBibliographyDetailRealService } from '@/services/ModalBibliographyDetailRealService'
import { ModalBibliographyDetailSetService } from '@/services/ModalBibliographyDetailSetService'
import { ModalReturnHistoryService } from '@/services/ModalReturnHistoryService'
import { ModalCollectionEditService } from '@/services/ModalCollectionEditService'
import { ModalOrderEditService } from '@/services/ModalOrderEditService'
import { ModalUpdateCollectionMemoService } from '@/services/ModalUpdateCollectionMemoService'
import { ModalBibliographyTagDataEditService } from '@/services/ModalBibliographyTagDataEditService'
import { ModalJobListService } from '@/services/ModalJobListService'
import { ModalCollectionSelectService } from '@/services/ModalCollectionSelectService'
import { ModalUpdateOrderMemoService } from '@/services/ModalUpdateOrderMemoService'
import { ModalProcessPlaceChangeService } from '@/services/ModalProcessPlaceChangeService'
import { ModalReceiptHistoryService } from '@/services/ModalReceiptHistoryService'
import { ModalQuickMenuService } from '@/services/ModalQuickMenuService'
import { ModalReturnCheckAlertService } from '@/services/ModalReturnCheckAlertService'

export const GlobalModalAlertService: ModalAlertService = new ModalAlertService()
export const GlobalModalErrorService: ModalErrorService = new ModalErrorService()

declare module 'vue/types/vue' {
  interface Vue {
    $modalAlert: ModalAlertService
    $modalReturnCheckAlert: ModalReturnCheckAlertService
    $modalBibliographyDetailReal: ModalBibliographyDetailRealService
    $modalBibliographyDetailSet: ModalBibliographyDetailSetService
    $modalBibliographySearchCondition: ModalBibliographySearchConditionService
    $modalBibliographySearchHistory: ModalBibliographySearchHistoryService
    $modalBibliographySearchResult: ModalBibliographySearchResultService
    $modalBibliographySearchResultAuthority: ModalBibliographySearchResultAuthorityService
    $modalBibliographySearchResultContent: ModalBibliographySearchResultContentService
    $modalBibliographyTagDataEdit: ModalBibliographyTagDataEditService
    $modalCode: ModalCodeService
    $modalCodeKey: ModalCodeKeyService
    $modalCollectionEdit: ModalCollectionEditService
    $modalCollectionSelect: ModalCollectionSelectService
    $modalError: ModalErrorService
    $modalJobList: ModalJobListService
    $modalOrderEdit: ModalOrderEditService
    $modalQuickMenu: ModalQuickMenuService
    $modalProcessPlaceChange: ModalProcessPlaceChangeService
    $modalReceiptHistory: ModalReceiptHistoryService
    $modalReturnHistory: ModalReturnHistoryService
    $modalShelfDiagram: ModalShelfDiagramService
    $modalUpdateCollectionMemo: ModalUpdateCollectionMemoService
    $modalUpdateOrderMemo: ModalUpdateOrderMemoService
    $modalUserDetail: ModalUserDetailService
    $modalUserSearch: ModalUserSearchService
  }
}

declare module '@nuxt/vue-app' {
  interface NuxtAppOptions {
    $modalAlert: ModalAlertService
    $modalReturnCheckAlert: ModalReturnCheckAlertService
    $modalBibliographyDetailReal: ModalBibliographyDetailRealService
    $modalBibliographyDetailSet: ModalBibliographyDetailSetService
    $modalBibliographySearchCondition: ModalBibliographySearchConditionService
    $modalBibliographySearchHistory: ModalBibliographySearchHistoryService
    $modalBibliographySearchResult: ModalBibliographySearchResultService
    $modalBibliographySearchResultAuthority: ModalBibliographySearchResultAuthorityService
    $modalBibliographySearchResultContent: ModalBibliographySearchResultContentService
    $modalBibliographyTagDataEdit: ModalBibliographyTagDataEditService
    $modalCode: ModalCodeService
    $modalCodeKey: ModalCodeKeyService
    $modalCollectionEdit: ModalCollectionEditService
    $modalCollectionSelect: ModalCollectionSelectService
    $modalError: ModalErrorService
    $modalJobList: ModalJobListService
    $modalOrderEdit: ModalOrderEditService
    $modalQuickMenu: ModalQuickMenuService
    $modalProcessPlaceChange: ModalProcessPlaceChangeService
    $modalReceiptHistory: ModalReceiptHistoryService
    $modalReturnHistory: ModalReturnHistoryService
    $modalShelfDiagram: ModalShelfDiagramService
    $modalUpdateCollectionMemo: ModalUpdateCollectionMemoService
    $modalUpdateOrderMemo: ModalUpdateOrderMemoService
    $modalUserDetail: ModalUserDetailService
  }
}

const plugin: Plugin = (context, inject) => {
  inject('modalAlert', GlobalModalAlertService)
  inject('modalReturnCheckAlert', new ModalReturnCheckAlertService())
  inject(
    'modalBibliographyDetailReal',
    new ModalBibliographyDetailRealService()
  )
  inject('modalBibliographyDetailSet', new ModalBibliographyDetailSetService())
  inject(
    'modalBibliographySearchCondition',
    new ModalBibliographySearchConditionService()
  )
  inject(
    'modalBibliographySearchHistory',
    new ModalBibliographySearchHistoryService()
  )
  inject(
    'modalBibliographySearchResult',
    new ModalBibliographySearchResultService()
  )
  inject(
    'modalBibliographySearchResultAuthority',
    new ModalBibliographySearchResultAuthorityService()
  )
  inject(
    'modalBibliographySearchResultContent',
    new ModalBibliographySearchResultContentService()
  )
  inject(
    'modalBibliographyTagDataEdit',
    new ModalBibliographyTagDataEditService()
  )
  inject('modalCode', new ModalCodeService())
  inject('modalCodeKey', new ModalCodeKeyService())
  inject('modalCollectionEdit', new ModalCollectionEditService())
  inject('modalCollectionSelect', new ModalCollectionSelectService())
  inject('modalError', GlobalModalErrorService)
  inject('modalJobList', new ModalJobListService())
  inject('modalOrderEdit', new ModalOrderEditService())
  inject('modalQuickMenu', new ModalQuickMenuService())
  inject('modalProcessPlaceChange', new ModalProcessPlaceChangeService())
  inject('modalReceiptHistory', new ModalReceiptHistoryService())
  inject('modalReturnHistory', new ModalReturnHistoryService())
  inject('modalShelfDiagram', new ModalShelfDiagramService())
  inject('modalUpdateCollectionMemo', new ModalUpdateCollectionMemoService())
  inject('modalUpdateOrderMemo', new ModalUpdateOrderMemoService())
  inject('modalUserDetail', new ModalUserDetailService())
  inject('modalUserSearch', new ModalUserSearchService())
}

export default plugin
